export const getBundleComponents = async (bundleItemsJson) => {
    let bundleItems;

    try {
        bundleItems = JSON.parse(bundleItemsJson);
    } catch {
        return [];
    }

    if (!Array.isArray(bundleItems) || bundleItems.length === 0) {
        return [];
    }

    const components = await Promise.all(bundleItems.map(async (bundleItem) => {
        const variantIdMatch = bundleItem.merchandiseId?.match(/\/ProductVariant\/(\d+)/);
        const variantId = variantIdMatch?.[1];
        const productHandle = bundleItem.productHandle;

        if (!productHandle || !variantId) {
            return null;
        }

        try {
            const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
            const product = await response.json();
            const variant = product.variants?.find(v => v.id.toString() === variantId);
            const title = variant && variant.title !== 'Default Title'
                ? `${product.title} - ${variant.title}`
                : product.title;

            return {
                quantity: bundleItem.quantity || 1,
                title,
            };
        } catch {
            return null;
        }
    }));

    return components.filter(Boolean);
};

export const renderBundleComponentsHTML = (components, className = 'fs-250') => {
    if (!components.length) {
        return '';
    }

    return components.map(component => (
        `<div class="${className}"><span>${component.quantity} x ${component.title}</span></div>`
    )).join('');
};
